import {createAxeptioScript} from './createAxeptioScript';
import {isAxeptioEnabled} from './isAxeptioEnabled';

export function AxeptioHead() {
  if (!isAxeptioEnabled()) {
    return null;
  }

  const clientId =
    (import.meta.env.VITE_AXEPTIO_CLIENT_ID as string | undefined)
      ?.trim() ?? '';
  const cookiesVersion =
    (import.meta.env.VITE_AXEPTIO_COOKIES_VERSION as string | undefined)
      ?.trim() ?? '';

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: createAxeptioScript(clientId, cookiesVersion),
      }}
    />
  );
}
